import { render } from "./ResultadosBusquedaLID.vue?vue&type=template&id=e2e242d0&scoped=true"
import script from "./ResultadosBusquedaLID.vue?vue&type=script&lang=js"
export * from "./ResultadosBusquedaLID.vue?vue&type=script&lang=js"

import "./ResultadosBusquedaLID.vue?vue&type=style&index=0&id=e2e242d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2e242d0"]])

export default __exports__